// extracted by mini-css-extract-plugin
module.exports = {"products-contaienr":"CategoryView_products-contaienr__giuTE","side-panel-open-grid-container":"CategoryView_side-panel-open-grid-container__tJhaJ"};